import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "../../../funcs/utils";
import { MAXIMUM_DISTRIBUTION_AGE } from "../../../constants/constants";
import { fetchChartInfo, getUserAge } from "../utils/helpers";

/* 
    Warning: Can't perform a React state update on an unmounted component. 
    This is a no-op, but it indicates a memory leak in your application. 
    To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function. 
*/

// The warning above is a false positive
// check out links below:
// https://github.com/facebook/react/pull/22114

// Read bottom of 4th answer
// https://stackoverflow.com/questions/54954385/react-useeffect-causing-cant-perform-a-react-state-update-on-an-unmounted-comp

// This warning occurs be cause we are setting state in the finally block and React thinks the component has unmounted by the time we set state.
// However, the component did not unmount and setting state is ok.

// creates a context
export const PotentialContext = createContext();

// create hook to use context
export const usePotential = () => useContext(PotentialContext);

// create provider component
export const PotentialProvider = ({ children, username, accountIndex }) => {
    // local states
    const [isLoading, setIsLoading] = useState(true);
    
    // context states
    const [userInfo, setUserInfo] = useState(null);

    // redux states
    const { token, onboarding_token } = useSelector(state => state.user);

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                setIsLoading(true);
                const { userData, irr } = await fetchChartInfo(token, onboarding_token, accountIndex, username);

                const { 
                    tda_item: { account_type }, 
                    user_info: { role_0_dob } , 
                    initial_portfolio_value, 
                    contributions, 
                    onboarding_item: { access_funds_years, spend_funds_years } 
                } = userData;

                const data = {
                    initialPortfolioValue: initial_portfolio_value,
                    accountType: account_type,
                    dateOfBirth: role_0_dob,
                    age: getUserAge(role_0_dob),
                    contributionItem: contributions,
                    investmentYears: spend_funds_years ? parseFloat(spend_funds_years) : "0",
                    distributionYears: access_funds_years ? parseFloat(access_funds_years) : "0",
                    distributionAgeIRA: MAXIMUM_DISTRIBUTION_AGE,
                    internalReturnRate: irr
                }
                setUserInfo(data);

            } catch (error) {  
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchUserInfo();
    }, [])

    const updateUserInfo = (newUserInfo) => {
        setUserInfo((prevState) => ({
            ...prevState,
            ...newUserInfo
        }))
    }

    if(isLoading) return (
        <div style={{display: 'flex', justifyContent: 'center'}}>
            <Spinner size={"2rem"} />
        </div>
    )
    return (
        <PotentialContext.Provider value={{ userInfo, setUserInfo, updateUserInfo}}>
            {children}
        </PotentialContext.Provider>
    )
}